import { Injectable } from '@angular/core'
import { DialogService } from '@tokeet-frontend/tv3-platform'
import { DocumentAutomationOverlayComponent } from '@tv3/containers/documents/automations/automation-overlay/document-automation-overlay.component'
import { AutomationViewGroup } from '@tokeet-frontend/automations'

@Injectable({
  providedIn: 'root',
})
export class DocumentAutomationOverlayService {
  constructor(private dialog: DialogService) {}

  public open(automationGroup?: AutomationViewGroup, duplicate = false) {
    return this.dialog.openDrawer(DocumentAutomationOverlayComponent, {
      panelClass: ['drawer-full-80'],
      data: { automationGroup, duplicate },
    })
  }
}
